import axios from 'axios';

import { baseUrl } from './index';

export const searchSuggestions = (searchParam: string) => {
  return axios.get<ISearchSuggestions>(
    `${baseUrl}/search/suggestions/?query=${searchParam}`
  );
};

export type ISearchSuggestions = string[];
